// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"55":"b5aff131","117":"b5aff131","924":"9126c106"}[chunkId] + ".css";
};